module.exports = "<title local-time local-time-tick-refresh local-time-format=\"TITLE\">Loading...</title>\n"


//////////////////
// WEBPACK FOOTER
// ./src/directives/titleTime/template.html
// module id = 171
// module chunks = 0